import { createContext, useContext } from 'react';
import type {
  AgingBucketDefinition,
  ArAgingCustomerRow,
  ArAgingTotals,
  ArCustomerProfileResponse,
  GetArSummaryResponse,
} from '@erp/rpc';

// ── AR analytics context ──────────────────────────────────────────────────────
// Non-tabular data the AR canvas widgets need (the shared report-canvas module
// only knows tabular datasets). The hosting section provides whatever the page
// already fetched — filters applied — so widgets stay in sync with the page
// without issuing their own queries.

export interface ARAnalyticsContextValue {
  aging: {
    totals: ArAgingTotals | null;
    customers: ArAgingCustomerRow[];
    bucketDefinitions: AgingBucketDefinition[];
    isLoading: boolean;
  };
  /** Org-wide dashboard aggregates (AR summary surface). */
  summary?: GetArSummaryResponse | null;
  summaryLoading?: boolean;
  /** Single-customer profile bundle (customer profile surface). */
  profile?: ArCustomerProfileResponse | null;
  profileLoading?: boolean;
  customerId?: string;
}

const ARAnalyticsContext = createContext<ARAnalyticsContextValue | null>(null);

export const ARAnalyticsProvider = ARAnalyticsContext.Provider;

export function useARAnalytics(): ARAnalyticsContextValue {
  const value = useContext(ARAnalyticsContext);
  if (!value) {
    throw new Error(
      'useARAnalytics must be used inside an ARAnalyticsProvider',
    );
  }
  return value;
}
